import styled from 'styled-components'
import { breakpoints } from '../../MediasQueries'
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px;
  gap: 20px;
  width: 100%;

  img {
    max-width: 400px;
    min-width: 220px;
    width: 100%;
  }
`
export const InfoImport = styled.button`
  margin: 0 auto;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 240px;
  height: 90px;
  font-weight: normal;
  border-radius: 4px;
  color: ${(props) => props.theme.brand};
  border: 1px solid ${(props) => props.theme.brand};
  background: rgba(56, 211, 92, 0.1);

  span:first-child {
    font-size: 20px;
  }
`

export const TitleImport = styled.div`
  font-size: 18px;
  font-weight: bold;
  span:first-child {
    display: flex;
    align-items: center;
    svg {
      color: ${(props) => props.theme.brand};
      margin-right: 7px;
    }
  }
`
export const DescriptionImport = styled.p`
  margin-top: 10px;
`

export const Description = styled.p``

export const Imports = styled.div`
  margin-top: 30px;
`
export const ImportButton = styled.div`
  margin-top: 10px;
  padding: 10px;
  width: 100%;

  display: flex;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.1);

  align-items: center;
  justify-content: space-between;

  @media (max-width: ${breakpoints.sm}) {
    flex-wrap: wrap;
    gap: 10px;
  }
`
